import React from "react"
import { FlexContainer } from "@carrotfertility/carotene"
import styled from "styled-components"
import { SelectButton } from "../../views/atoms/buttons/SelectButton"
interface ButtonSelectGroupProps {
  onClick: (id: string) => void
  options: Array<{ title: string; id: string }>
  selected?: string
  multiSelected?: Array<string>
  loading?: boolean
}

const ButtonList = styled.ul({
  "> *": {
    ":not(:last-child)": {
      marginBottom: "4px",
      listStyled: "none"
    }
  }
})

const ButtonListItem = styled.li({
  "&::before": {
    content: "none"
  }
})

export default function ButtonSelectGroup({
  onClick,
  options,
  selected = null,
  multiSelected = null,
  loading = false
}: ButtonSelectGroupProps): JSX.Element {
  return (
    <ButtonList>
      {options.map((option) => (
        <ButtonListItem key={option.id}>
          <FlexContainer justifyContent="flex-end">
            <SelectButton
              disabled={loading}
              outline={multiSelected ? multiSelected.includes(option.id) : selected === option.id}
              type="button"
              onClick={(e) => {
                onClick(option.id)
                const target = e.target as HTMLButtonElement
                target.blur()
              }}
            >
              {option.title}
            </SelectButton>
          </FlexContainer>
        </ButtonListItem>
      ))}
    </ButtonList>
  )
}
